import {useMemo} from 'react'
import {useSelector, useDispatch} from 'react-redux'
import {
  setShowPopulationDensityTable as setShowPopulationDensityTableAction,
  setShowPopulationDistributionTable as setShowPopulationDistributionTableAction,
  setShowRiskOverTimeTable as setShowRiskOverTimeTableAction,
  setShowPopulationOverTimeTable as setShowPopulationOverTimeTableAction,
  setSelectedLabel as setSelectedLabelAction,
  clearTableView as clearTableViewAction,
  selectShowPopulationDensityTable,
  selectShowPopulationDistributionTable,
  selectShowRiskOverTimeTable,
  selectShowPopulationOverTimeTable,
  selectSelectedLabel
} from '../slices/tableViewSlice'

export const useTableViewContext = () => {
  const dispatch = useDispatch()
  const showPopulationDensityTable = useSelector(selectShowPopulationDensityTable)
  const showPopulationDistributionTable = useSelector(selectShowPopulationDistributionTable)
  const showRiskOverTimeTable = useSelector(selectShowRiskOverTimeTable)
  const showPopulationOverTimeTable = useSelector(selectShowPopulationOverTimeTable)
  const selectedLabel = useSelector(selectSelectedLabel)

  const updateTogglePopulationDensity = (value) => {
    dispatch(setShowPopulationDensityTableAction(value))
  }

  const updateTogglePopulationDistribution = (value) => {
    dispatch(setShowPopulationDistributionTableAction(value))
  }

  const updateToggleRiskOverTime = (value) => {
    dispatch(setShowRiskOverTimeTableAction(value))
  }

  const updateTogglePopulationOverTime = (value) => {
    dispatch(setShowPopulationOverTimeTableAction(value))
  }

  const updateSelectedLabel = (value) => {
    dispatch(setSelectedLabelAction(value))
  }

  const clearTable = () => {
    dispatch(clearTableViewAction())
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useMemo(
    () => ({
      showPopulationDensityTable,
      updateTogglePopulationDensity,
      setShowPopulationDensityTable: updateTogglePopulationDensity,
      showPopulationDistributionTable,
      updateTogglePopulationDistribution,
      setShowPopulationDistributionTable: updateTogglePopulationDistribution,
      showRiskOverTimeTable,
      updateToggleRiskOverTime,
      setShowRiskOverTimeTable: updateToggleRiskOverTime,
      showPopulationOverTimeTable,
      updateTogglePopulationOverTime,
      setShowPopulationOverTimeTable: updateTogglePopulationOverTime,
      selectedLabel,
      setSelectedLabel: updateSelectedLabel,
      clearTableView: clearTable
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      showPopulationDensityTable,
      showPopulationDistributionTable,
      showRiskOverTimeTable,
      showPopulationOverTimeTable,
      selectedLabel
    ]
  )
}
